import AnalyticsAction from '../actions/AnalyticsCRUDActions';
import Actions from '../actions/actions';
import { setBusy, setUnBusy } from './common/commonReducers';
import { Analytics } from '../interfaces/analytics';

const initialState: Analytics = {
  busy: false,
  analytics: undefined,
};

const resetAnalytics = (): Analytics => initialState;

export default function analytics(state = initialState, action) {
  switch (action.type) {
    case AnalyticsAction.busyAction:
      return setBusy(state);
    case AnalyticsAction.retrievedAction: {
      return {
        ...state,
        analytics: action.entity,
        busy: false,
      };
    }
    case Actions.UNBUSY:
      return setUnBusy(state);
    case Actions.RESET:
      return resetAnalytics;
    case AnalyticsAction.resetAnalyticsAction:
      return resetAnalytics;
    default:
      return state;
  }
}
